export var isFocusableHtmlElement = function (element) {
    if (!element) {
        return false;
    }
    return element['focus'] instanceof Function && element !== document.body;
};
//# sourceMappingURL=isFocusableHtmlElement.js.map